import "./style.css";

export const BtnCustom = ({ text, isSubmitting, onClick, onKeyDown = () => {}, className = "" }) => {
	return (
		<button
			type="button"
			onClick={(event) => onClick(event)}
			onKeyDown={onKeyDown}
			className={`${className}`}
			disabled={isSubmitting}
		>
			{!isSubmitting ? (
				text
			) : (
				<>
					{text}
					<div>
						<span
							className="spinner-grow custom-spinner spinner-grow-sm text-color me-2"
							role="status"
						></span>
						<span
							className="spinner-grow custom-spinner spinner-grow-sm text-color me-2"
							role="status"
						></span>
					</div>
				</>
			)}
		</button>
	);
};
